import { PageType } from "~/lib/router/enums";

export const pathname = "/story-style";

export const page = {
  route(
    query: QueryParameters<{
      subSection: string;
    }>,
  ) {
    return {
      cacheMaxAge: 60,
      pathname,
      query: { ...query, pageType: PageType.StoryStyle },
    };
  },
};
